import React, { useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { compose, withActions, withFarmContext } from "containers/HOC";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import TileBodyMessage from "components/TileBodyMessage";
import Loader from "components/Loader";
import NotFound from "components/NotFound";
import FarmAccessDenied from "containers/Farm/FarmAccessDenied";
import { closeModal } from "containers/App/_actions";
import { fetchFarm } from "containers/Farm/_actions";
import { fetchBudget } from "containers/Budget/_actions";
import { AkuakuContext } from "common/AkuakuContext";

export default function FarmRoute(FarmComponent) {
    const FarmRoute = (props) => {
        const { farmId, budgetId, fetchFarm, fetchBudget, closeModal, farm, budget, farmNotFound, farmAccessDenied, farmIsLoading } = props;

        const [, setContext] = useContext(AkuakuContext);

        useEffect(() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            // make sure modal is reset if screen is refreshed
            closeModal();
        }, [closeModal]);

        useEffect(() => {
            if (budgetId) fetchBudget(farmId, budgetId, false);
        }, [budgetId, farmId, fetchBudget]);

        useEffect(() => {
            if (farmId && !budgetId) fetchFarm(farmId, false, null);
        }, [farmId, budgetId, fetchFarm]);

        const farmName = farm?.name?.replace("%", "");
        const budgetName = budget?.name?.replace("%", "");

        useEffect(() => {
            if (farm) setContext((ctx) => ({ ...ctx, lastFarmName: farmName, lastBudgetName: budgetName }));
        }, [budgetName, farm, farmName, setContext]);

        if (farmNotFound) return <NotFound />;

        if (farmAccessDenied) return <FarmAccessDenied {...props} />;

        if (farm && !farm.IsNew) return <FarmComponent {...props} />;

        // IMPORTANT: Loading must be after NotFound, FarmAccessDenied and FarmComponent.
        if (farmIsLoading || (farm || {}).IsNew) return <Loader message="Loading..." />;

        return (
            <Tile>
                <TileBody>
                    <TileBodyMessage>
                        <p className="lead">Farm currently not available</p>
                        <p>Try reloading the farm from the Dashboard or checking your internet connection</p>
                    </TileBodyMessage>
                </TileBody>
            </Tile>
        );
    };

    return compose(withRouter, withFarmContext, withActions({ fetchFarm, fetchBudget, closeModal }))(FarmRoute);
}
